import { navigateTo, simpleRoute } from '../../common/frontend/route-utils.js'
import { Spinner } from '../components/spinner/spinner.js'
import { View } from '../types.js'

class ProfileModel {
    // Legacy redirect — the profile now lives under the /me namespace. Old
    // ?tab= deep links map onto the matching /me/<section> path.
    public route = simpleRoute<View>('/profile', {
        onEnter: () => {
            const tab = new URLSearchParams(window.location.search).get('tab')
            const target =
                tab === 'time-away'
                    ? '/me/time-away'
                    : tab === 'settings' || tab === 'integrations'
                      ? '/me/settings'
                      : '/me'
            navigateTo(target)
        },
        render: () => <Spinner />,
    })
}

export const profileModel = new ProfileModel()
